import React, { useState } from "react";
import axios from "axios";
import { MyApiUrl } from "./services";

const ForgotPassword = () => {
  const [Email, setEmail] = useState("");
  const [OTPVerify, setOTPVerify] = useState(false);
  const [OTP, setOTP] = useState("");

  const UserLogin = async () => {
    if (Email === "" || Email == null) {
      alert("PLease Enter Email Address");
    } else {
      var obj = {
        Email: Email,
      };
      axios.post(MyApiUrl + "SendForgotPasswordLink", obj).then((response) => {
        if (response.data) {
          alert("Forgot Password OTP Sent To Your Email Address");
          setOTPVerify(true);
        } else {
          alert("Email Not Found ...!");
        }
      });
    }
  };

  const VerifyOTP = async () => {
    if (OTP === "" || OTP == null) {
      alert("Please Enter OTP");
    } else {
      var obj = {
        Email: Email,
        OTP: OTP,
      };
      axios.post(MyApiUrl + "VerifyOTP", obj).then((response) => {
        if (response.data) {
          alert("OTP Verified, Please Change Your Password");
          localStorage.setItem("ForgotPasswordEmail", Email);
          window.location.href = "/UpdatePassword";
        } else {
          alert("Wrong OTP ....!");
        }
      });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content bg-white">
        <div className="login-account">
          <div className="row h-100">
            <div className="col-lg-8 align-self-start m-b30">
              <div
                className="account-info-area"
                style={{
                  backgroundImage: "url(assets/images/pattern/bg-pattern1.png)",
                }}
              >
                <div className="row h-100 align-items-center">
                  <div className="col-xl-12 col-md-12 col-sm-12">
                    <img
                      style={{ width: "100%" }}
                      alt="Img"
                      src="assets/images/logo/Logo.jpg"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-7 col-sm-8 mx-auto align-self-center">
              <div className="login-form">
                <div className="login-head">
                  <h3 className="title">Forgot Password</h3>
                  {/* <p>Lorem ipsum dolor sit amet consectetur adipiscing</p> */}
                </div>
                <h6 className="login-title">
                  <span>From Here</span>
                </h6>
                <form className="form" method="POST" action="#">
                  <div className="form-group m-b30">
                    <label className="form-label text-secondary">
                      Email Address
                    </label>
                    <div className="input-group input-line">
                      <input
                        name="dzEmail"
                        required
                        type="text"
                        className="form-control"
                        placeholder="info@example.com"
                        value={Email}
                        readOnly={OTPVerify}
                        onChange={(event) => {
                          setEmail(event.target.value);
                        }}
                      />
                    </div>
                    {OTPVerify ? (
                      <div className="input-group input-line">
                        <input
                          name="dzEmail"
                          required
                          type="text"
                          className="form-control"
                          placeholder="OTP ..."
                          value={OTP}
                          onChange={(event) => {
                            setOTP(event.target.value);
                          }}
                        />
                      </div>
                    ) : null}
                  </div>
                  {OTPVerify ? (
                    <button
                      name="submit"
                      type="button"
                      value="Submit"
                      onClick={VerifyOTP}
                      className="btn btn-secondary shadow-secondary w-100"
                    >
                      Verify OTP
                    </button>
                  ) : (
                    <button
                      name="submit"
                      type="button"
                      value="Submit"
                      onClick={UserLogin}
                      className="btn btn-secondary shadow-secondary w-100"
                    >
                      Send OTP
                    </button>
                  )}

                  <p className="text-center m-t30">
                    <a className="font-weight-500" href="/">
                      Login Here
                    </a>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ForgotPassword;
